// extracted by mini-css-extract-plugin
export default {"container":"Usuario_container__lVNmR","foto":"Usuario_foto__QrYFX","iconeUsuario":"Usuario_iconeUsuario__J3acO","nomeUsuario":"Usuario_nomeUsuario__bsiE1"};